module.exports = __webpack_public_path__ + "static/media/智慧门店解决方案.c6bb5de0.png";